export const createUnpaidNoticationBtnUrl = async (customerType: string, contractId: string) => {
    let url = '';
    const environment = process.env.REACT_APP_STAGE;

    switch (environment?.toLowerCase()) {
        case 'dev':
            url = 'https://vwfs.dev.ocfr.vwfs.io/';
            break;
        case 'int':
            url = 'https://vwfs.int.ocfr.vwfs.io/';
            break;
        case 'cons':
            url = 'https://vwfs.cons.ocfr.vwfs.io/';
            break;
        case 'prod':
            url = 'https://gerermonimpaye.vwfs.fr/';
            break;
        default:
            break;
    }

    switch (customerType.toLowerCase()) {
        case 'retail':
            url += 'retail';
            break;
        case 'bic':
        case 'ba':
        case 'bnc':
            url += 'sme';
            break;
        case 'part':
            url += 'fleet';
            break;
        default:
            break;
    }

    url += `?ref_id=${contractId}&?traci_s=:ALL:ORG:VWFS:Website::OC_CCP&traci_ie=::::CCP`;

    return url;
};
